<template>
  <b-modal
    id="'salvarArquivo'"
    :ref="'salvarArquivo'"
    hide-footer
    hide-header
    centered
    size="md"
    no-close-on-backdrop
    content-class="salvar-arquivo"
  >
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="12">
            <b-button
              variant="none"
              class="close "
              @click="cancelar()"
            >
              <span aria-hidden="true">&times;</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            style="text-align:justify;"
          >
            <h4>
              Escolha o documento que você deseja enviar!
            </h4>
            <p
              class="text-secondary"
              style="font-size:small"
            >
              Ao realizar essa ação você publicará o documento e uma notificação será enviada a contabilidade para realizar a homologação.
            </p>
          </b-col>
          <div
            class="mt-1 px-1"
            style="flex-grow:1"
          >
            <b-row>
              <b-col cols="12">
                <carregar-arquivo
                  ref="upload"
                  v-model="arquivo"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Adicione uma observação sobre este documento">
                  <b-textarea
                    v-model="observacao"
                    placeholder="Observação (opcional)"
                    rows="3"
                    max-rows="6"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col cols="6">
                <b-btn
                  variant="danger"
                  class="w-100"
                  @click="cancelar()"
                >Cancelar</b-btn>
              </b-col>
              <b-col cols="6">
                <b-btn
                  variant="success"
                  class="w-100"
                  @click="fechar()"
                >Publicar</b-btn>
              </b-col>
            </b-row>
          </div>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<style lang="scss">
.salvar-arquivo {
  width: auto !important;
}
</style>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'NaoSeAplica',
  components: {
    CarregarArquivo: () => import('@/shared/components/carregar-arquivo/CarregarArquivo.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      arquivo: null,
      observacao: '',
      maxSize: 536870912, // 512mb
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.salvarArquivo.show()
    })
  },
  methods: {
    cancelar() {
      this.$refs.salvarArquivo.hide()
      this.$emit('cancelar')
    },
    fechar() {
      const arquivo = this.$refs.upload.valueInner
      if (arquivo.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'É obrigatório selecionar um arquivo.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } else if (arquivo[0].size > this.maxSize) {
        this.$erro('Tamanho do arquivo excedeu o limite de 512mb')
      } else {
        this.$refs.salvarArquivo.hide()
        const formData = this.$refs.upload.getFormDataBody(this.observacao)
        this.$emit('hidden', formData)
      }
    },
  },
}
</script>
